module.exports = __webpack_public_path__ + "img/katarina_amenities_11.0295c255.jpg";